import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  originalData: [],
  data: [],
};

const dataSlice = createSlice({
  name: 'data',
  initialState,
  reducers: {
    setData(state, action) {
      state.data = action.payload;
      state.originalData = action.payload;
    },

    deletePolicy(state, action) {
      const idToDelete = action.payload;
      state.data = state.data.filter(item => item._id !== idToDelete);
      state.originalData = state.originalData.filter(item => item._id !== idToDelete);
    },
    
    updatePolicy(state, action) {
      const updatedPolicy = action.payload;
      const index = state.data.findIndex(item => item._id === updatedPolicy._id);
      if (index !== -1) {
        state.data[index] = updatedPolicy;
        state.originalData[index] = updatedPolicy;
      }
    },
    addPolicy(state, action) {
      const newPolicy = action.payload;
      state.data.push(newPolicy);
      state.originalData.push(newPolicy);
    },
    increaseSmsCount(state, action) {
      const policyId = action.payload;
      const policyIndex = state.data.findIndex(item => item._id === policyId);
      if (policyIndex !== -1) {
        state.data[policyIndex].smsSentCount += 1;
        state.originalData[policyIndex].smsSentCount += 1;
      }
    }
  },
});

export const { setData, deletePolicy, updatePolicy, addPolicy, increaseSmsCount } = dataSlice.actions;
export default dataSlice.reducer;
